import { KeyRound, AlertTriangle } from "lucide-react";

const steps = [
  ["Utwórz aplikację", "Wejdź na discord.com/developers/applications → New Application → zakładka Bot → Reset Token i skopiuj token."],
  ["Włącz intencje", "W zakładce Bot włącz „Message Content Intent” (wymagane dla komend z prefiksem) i zapisz."],
  ["Wklej token", "Dodaj token do pliku backend/.env jako DISCORD_TOKEN=\"...\" (albo przekaż go w czacie, a skonfiguruję to za Ciebie)."],
  ["Zaproś bota", "Po uruchomieniu w nagłówku pojawi się przycisk „Zaproś bota” z gotowym linkiem OAuth2."],
];

export default function SetupGuide({ status }) {
  return (
    <section className="card p-6 sm:p-8 relative overflow-hidden fade-up" data-testid="setup-guide">
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-indigo-500/10 blur-3xl" />
      <div className="flex items-start gap-4 relative">
        <div className="h-11 w-11 rounded-lg bg-amber-500/15 border border-amber-500/40 grid place-items-center shrink-0">
          {status?.error ? <AlertTriangle className="h-5 w-5 text-amber-400" /> : <KeyRound className="h-5 w-5 text-amber-400" />}
        </div>
        <div className="flex-1">
          <div className="caption text-amber-400">konfiguracja</div>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mt-1">
            {status?.token_configured ? "Bot się łączy…" : "Bot czeka na token Discord"}
          </h2>
          {status?.error && (
            <p className="mt-2 text-sm text-red-300 font-mono" data-testid="bot-error-message">{status.error}</p>
          )}
          <p className="mt-2 text-slate-400 max-w-2xl">
            Lavalink jest {status?.lavalink?.online ? "uruchomiony i gotowy" : "niedostępny"}. Wyszukiwarka poniżej działa już teraz —
            po dodaniu tokena odblokujesz pełne sterowanie odtwarzaniem.
          </p>
          <ol className="mt-6 grid sm:grid-cols-2 gap-4">
            {steps.map(([t, d], i) => (
              <li key={t} className="rounded-lg border border-slate-800 bg-slate-950/40 p-4" data-testid={`setup-step-${i + 1}`}>
                <div className="font-mono text-xs text-emerald-400">0{i + 1}</div>
                <div className="font-heading font-semibold mt-1">{t}</div>
                <div className="text-sm text-slate-400 mt-1 leading-relaxed">{d}</div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
